import { gh, isExecute, vueDefineComponent } from '@syncfusion/ej2-vue-base';
import { isNullOrUndefined } from '@syncfusion/ej2-base';
export let Chart3DColumnsDirective = vueDefineComponent({
    inject: { custom: { default: null } },
    render(createElement) {
        if (!isExecute) {
            let h = !isExecute ? gh : createElement;
            let slots = null;
            if (!isNullOrUndefined(this.$slots.default)) {
                slots = !isExecute ? this.$slots.default() : this.$slots.default;
            }
            return h('div', { class: 'e-directive' }, slots);
        }
        return;
    },
    updated() {
        if (!isExecute && this.custom) {
            this.custom();
        }
    },
    methods: {
        getTag() {
            return 'e-chart3d-columns';
        }
    }
});
export const Chart3DColumnsPlugin = {
    name: 'e-chart3d-columns',
    install(Vue) {
        Vue.component(Chart3DColumnsPlugin.name, Chart3DColumnsDirective);
    }
};
export let Chart3DColumnDirective = vueDefineComponent({
    render() {
        return;
    },
    methods: {
        getTag() {
            return 'e-chart3d-columns';
        }
    }
});
export const Chart3DColumnPlugin = {
    name: 'e-chart3d-columns',
    install(Vue) {
        Vue.component(Chart3DColumnPlugin.name, Chart3DColumnDirective);
    }
};
